import React from "react";
import GenericList from "../../components/lists/GenericList";
import { listTextTransforms } from "../../actions/text-transform/listTextTransforms";

const TextTransformList: React.FC<{
  refresh: boolean;
  onRefreshComplete: () => void;
}> = ({ refresh, onRefreshComplete }) => {
  return (
    <GenericList
      fetchData={listTextTransforms}
      refresh={refresh}
      onRefreshComplete={onRefreshComplete}
    />
  );
};

export default TextTransformList;
